import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFilters } from '../contexts/FilterContext';

interface Props {
  children: React.ReactNode;
}

const TherapeuticAreaInitializer: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const { filters, updateFilter } = useFilters();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!user) return;

    let targetArea = filters.therapeuticArea;
    let needsUpdate = false;

    // Logic to determine the correct initial therapeutic area
    if (user.role === 'trial') {
      if (targetArea !== 'Skin Cancer - Trial Version') {
        targetArea = 'Skin Cancer - Trial Version';
        needsUpdate = true;
      }
    } else if (user.effective_therapeutic_areas?.length > 0) {
      // If current TA is not in the list of allowed TAs, default to the first one
      if (!user.effective_therapeutic_areas.includes(targetArea) || !targetArea) {
        targetArea = user.effective_therapeutic_areas[0];
        needsUpdate = true;
      }
    } else if (user.role === 'admin') {
      if (targetArea !== 'Dermatology') {
        targetArea = 'Dermatology';
        needsUpdate = true;
      }
    } else if (user.role === 'customer') {
      // For customer role, check if they have trial version access
      if (user.effective_therapeutic_areas?.includes('Skin Cancer - Trial Version')) {
        if (targetArea !== 'Skin Cancer - Trial Version') {
          targetArea = 'Skin Cancer - Trial Version';
          needsUpdate = true;
        }
      } else if (user.effective_therapeutic_areas?.length > 0) {
        if (!user.effective_therapeutic_areas.includes(targetArea) || !targetArea) {
          targetArea = user.effective_therapeutic_areas[0];
          needsUpdate = true;
        }
      }
    }

    if (needsUpdate) {
      updateFilter('therapeuticArea', targetArea);
    }
    
    // Mark as initialized once logic has run
    setIsInitialized(true);

  }, [user, filters.therapeuticArea, updateFilter]);

  // Render children only after initialization is complete
  if (!isInitialized) {
    return null; // Or a loading spinner
  }

  return <>{children}</>;
};

export default TherapeuticAreaInitializer;
